<template>
  <div>
    <div class="form-group row mb-2">
      <label class="col-sm-4  text-lr">
        <i v-if=" Data.data.c_priority==='S'" class="fa fa-asterisk text-danger font10 ml-1"
           aria-hidden="true"></i>{{ Data.data.c_name }}：</label>
      <div class="col-sm-7 ">
        <el-radio-group v-model="value" @change="$get_function(Data,value)">
          <el-radio :label=Data.data.c_choice.map[0] style="margin-bottom: 0">
            {{ Data.data.c_choice.map[0] }}
          </el-radio>
          <el-radio :label=Data.data.c_choice.map[1] style="margin-bottom: 0">
            {{ Data.data.c_choice.map[1] }}
          </el-radio>
        </el-radio-group>
        {{ Data.data.c_unit }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "sole_select",
  props: [
    'Data'
  ],
  data() {
    return {
      value:this.Data.data.c_value,
      formLabelWidth: '200px',
    }
  },
  created() {
  },
  methods: {}
}
</script>
<style scoped>
</style>